import { isApplicationModeInfinity } from 'src/data/system';
import { isInIframe } from 'src/lib/browser';

import { useApplicationMode } from './useApplicationMode';

export const useIsApplicationModeInfinity = () => {
  const applicationMode = useApplicationMode();

  // We want to make sure we are embedded in an iframe
  if (!isInIframe()) {
    return false;
  }

  return isApplicationModeInfinity(applicationMode);
};
